const largeAccordion = () => {
    const selectors = {
        accordion: '[data-large-accordion-tab]',
        accordionTitle: '[data-large-accordion-tab-title]',
        accordionContent: '[data-large-accordion-tab-content]',
        openOnLoad: 'open-on-load',
    };
    const classes = {
        accordionOpen: 'large-accordion__tab--open',
    };
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        accordion.classList.add(classes.accordionOpen);
        content.style.maxHeight = content.scrollHeight + 'px';
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(selectors.accordionContent);
        accordion.classList.remove(classes.accordionOpen);
        content.style.maxHeight = null;
    };
    const largeAccordions = document.querySelectorAll(selectors.accordion);
    largeAccordions.forEach((accordion) => {
        const title = accordion.querySelector(selectors.accordionTitle);
        const content = accordion.querySelector(selectors.accordionContent);
        if (content.hasAttribute(selectors.openOnLoad)) {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
        if (title && content) {
            title.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                }
                else {
                    largeAccordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        }
    });
    window.addEventListener('resize', () => {
        largeAccordions.forEach((accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            if (content && content.style.maxHeight) {
                openAccordion(accordion);
            }
        });
    });
};
export { largeAccordion };
